import { baseFilesURL } from 'App/api/agent/axios/configuration';

export const getProductImgUrl = (product: any) => {
	if (product && product.image && product.image.url) {
		return `${baseFilesURL}uploads/images/${product.image.url}`;
	}

	return require('../../../common/assets/products/tikka_masala_2_placeholder.jpg');
};
